import { array, Decoder, field, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../Resource/Decoders';
import { TypeaheadPayload, TypeaheadResource } from './Types';

export const typeaheadPayloadDecoder = <T>(itemDecoder: Decoder<T>): Decoder<TypeaheadPayload<T>> =>
  succeed({})
    .assign('query', field('query', string))
    .assign('suggestions', field('suggestions', array(itemDecoder)));

export const typeaheadResourceDecoder = <T>(
  itemDecoder: Decoder<T>,
): Decoder<TypeaheadResource<T>> => resourceDecoder(typeaheadPayloadDecoder(itemDecoder));
